import { Component } from 'react';
import requester from "../library/Requester"; 
import { Col, Form, Modal, Row } from 'react-bootstrap';
import CommonButton from './components/CommonButton';

export const RESET_PASS_TYPE = Object.freeze({
    EXTERNAL_USER: 'external-user',
    BACK_OFFICE: 'back-office',
});

const URL = 'public/view/forget-password';

class SendEmailResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            fadingOut: false,
            source: '',
            loading: false,
            email: '',
            emailError: '',
        };
    }
    
    open = (source = '') => {
        this.setState({ show: true, fadingOut: false, source: source });
    };

    close = () => {
        this.setState({ fadingOut: true });
        setTimeout(() => {
            this.setState({ show: false, fadingOut: false });
        }, 200);
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

           this.setState({
                email: value,
                emailError: value === '' || emailRegex.test(value) ? '' : 'รูปแบบอีเมลไม่ถูกต้อง',
                errorMessage: '',
                successMessage: '',
            });
            return;
        }

        this.setState({ [name]: value });
    };

    SendEmailReset = async () => {
        try {

            this.setState({
                loading: true,
                errorMessage: '',
                successMessage: '',
            });

            const body = {
                email: this.state.email,
                ut: this.state.source,
            };

            const result = await requester.post(`${URL}`, body);

            if (result?.data?.status === 200) {
                this.setState({
                    successMessage: 'ระบบได้ส่งอีเมลรีเซ็ตรหัสผ่านเรียบร้อยแล้ว',
                });

            } else {
                this.setState({
                    errorMessage: result?.data?.message || 'ไม่สามารถส่งอีเมลได้',
                });

            }

        } catch (error) {

            this.setState({
                errorMessage: 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้',
                successMessage: '',
            });

        } finally {

            this.setState({
                loading: false,
            });

        }
    };
    handleConfirm = async () => {
        this.SendEmailReset();        
    };

    render() {
        const { show, fadingOut, loading, email, emailError, successMessage, errorMessage } = this.state;
        const { resetPassType } = this.props;

        const isBackOffice = (resetPassType ?? RESET_PASS_TYPE.EXTERNAL_USER) === RESET_PASS_TYPE.BACK_OFFICE;
        const colorTheme = isBackOffice ? '#0E3362' : '#f99e39';
        return (
            <Modal
                show={show && !fadingOut}
                centered
                size='me'
                backdrop='static'
                keyboard={false}
                onHide={this.close}
                className={fadingOut ? 'modal-fade-out' : ''}
            >
                <Modal.Header closeButton style={{ backgroundColor: colorTheme, color: '#ffffff' }}>
                    <span >{`กรอกอีเมลเพื่อรับช่องทางรีเซ็ทรหัสผ่าน`}</span>
                </Modal.Header>

                <Modal.Body>
                    <Row className='flex-fill'>
                        <Form.Group className='mb-3'>
                            <Form.Label>อีเมล</Form.Label>
                            <div style={{ position: 'relative' }}>
                                <Form.Control
                                    type="email"
                                    placeholder="อีเมล"
                                    name="email"
                                    value={email}
                                    onChange={this.handleInputChange}
                                    isInvalid={!!emailError}
                                />

                                <Form.Control.Feedback type="invalid">
                                    {emailError}
                                </Form.Control.Feedback>
                                
                                {
                                    errorMessage &&
                                    <div  className='mt-3'
                                        style={{
                                            color: '#dc3545',
                                            fontSize: '0.875rem',
                                            marginTop: '0.25rem',
                                        }}
                                    >
                                        {errorMessage}
                                    </div>
                                }

                                {
                                    successMessage &&
                                    <div  className='mt-3'
                                        style={{
                                            color: '#198754',
                                            fontSize: '0.875rem',
                                            marginTop: '0.25rem',
                                        }}
                                    >
                                        {successMessage}
                                    </div>
                                }
                            </div>
                        </Form.Group>
                    </Row>

                </Modal.Body>

                <Modal.Footer>
                    <CommonButton
                        size='sm'
                        loading={loading}
                        task='sent-data'
                        callback={this.handleConfirm}
                    />

                    {/* <CommonButton
                        size='sm'
                        inlineClass='ms-0'
                        task='back-to-login'
                        callback={this.close}
                    /> */}
                </Modal.Footer>
            </Modal>
        );
    }
}

export default SendEmailResetPassword;
